import type { ADFEntity } from '@atlaskit/adf-utils/types';
import { canViewRequest } from '../rest';
import { getSmartCardUrl } from '../smart-card-provider';

export class PortalAutoformattingProvider {
    getRules() {
        return Promise.resolve({
            '([A-Z][A-Z0-9_]+-\\d+)': async (match: string[]): Promise<ADFEntity> => {
                const issueKey = match[1];
                const canViewRequestInPortal = await canViewRequest(issueKey);
                if (canViewRequestInPortal) {
                    return {
                        type: 'inlineCard',
                        attrs: {
                            url: getSmartCardUrl(issueKey),
                        },
                    };
                }
                return {
                    type: 'text',
                    text: issueKey,
                };
            },
        });
    }
}
